import { useEffect, useState } from "react";
import { readFilmStore } from "@tour/film.js";
import { CHAOS_FLASHES, CHAOS_REUNION_AT, CHAOS_SHATTER_AT, SHOTS, flashOpacity } from "@tour/shots.js";

const CHAOS_AT = SHOTS.find((shot) => shot.id === "chaos-desk")?.at ?? 70;
const SHARDS = [
  { x: 0, y: 0 },
  { x: 1, y: 0 },
  { x: 2, y: 0 },
  { x: 0, y: 1 },
  { x: 1, y: 1 },
  { x: 2, y: 1 },
  { x: 0, y: 2 },
  { x: 1, y: 2 },
  { x: 2, y: 2 },
];

function chaosAge() {
  const store = readFilmStore() || {};
  if (store.paused && typeof store.elapsed === "number") return Math.max(0, store.elapsed - CHAOS_AT);
  if (!store.t0) return 0;
  return Math.max(0, (Date.now() - store.t0) / 1000 - CHAOS_AT);
}

function flashShow(flash, age) {
  if (age >= CHAOS_SHATTER_AT) return Math.max(0, 1 - (age - CHAOS_SHATTER_AT) / 0.7);
  if (age >= CHAOS_REUNION_AT) {
    const t = age - CHAOS_REUNION_AT;
    return t < 0.55 ? t / 0.55 : 1;
  }
  return flashOpacity(flash, age);
}

export default function FilmChaos() {
  const [age, setAge] = useState(0);

  useEffect(() => {
    const tick = window.setInterval(() => setAge(chaosAge()), 50);
    return () => window.clearInterval(tick);
  }, []);

  const shatter = age >= CHAOS_SHATTER_AT;

  return (
    <article className={`film-still film-still--chaos${shatter ? " is-shatter" : ""}`} data-tour="film-still">
      {shatter ? (
        <div className="film-chaos__shards" aria-hidden="true">
          {SHARDS.map((shard, index) => (
            <span
              key={`${shard.x}-${shard.y}`}
              className="film-chaos__shard"
              style={{
                backgroundImage: "url(/images/film/film-messy-desk.png)",
                backgroundPosition: `${shard.x * 50}% ${shard.y * 50}%`,
                animationDelay: `${index * 0.04}s`,
                "--dx": `${(shard.x - 1) * 42}vw`,
                "--dy": `${(shard.y - 1) * 34}vh`,
                "--rot": `${(index - 4) * 11}deg`,
              }}
            />
          ))}
        </div>
      ) : (
        <img src="/images/film/film-messy-desk.png" alt="A messy real estate desk" />
      )}
      {CHAOS_FLASHES.map((flash) => (
        <p
          key={flash.text}
          className="film-flash"
          style={{
            top: flash.top,
            left: flash.left,
            transform: `rotate(${flash.rotate}deg)`,
            opacity: flashShow(flash, age),
          }}
        >
          {flash.text}
        </p>
      ))}
    </article>
  );
}
